export const IDS = {
  // Nav / header
  navLogo: 'nav-logo',
  navMenu: 'nav-menu',
  navBookBtn: 'nav-book-btn',

  // Hero
  heroTitle: 'hero-title',
  heroCta: 'hero-cta-primary',
  heroScroll: 'hero-scroll-indicator',

  // Sections
  sectionFestival: 'section-festival-tours',
  sectionWeekly: 'section-weekly-tours',
  sectionGirls: 'section-girls-trip',
  sectionAli: 'section-about-ali',
  sectionReviews: 'section-reviews',
  sectionContacts: 'section-contacts',

  // Tour card
  tourCard: (slug) => `tour-card-${slug}`,
  tourCardCta: (slug) => `tour-card-cta-${slug}`,

  // Tour page
  tourBookBtn: 'tour-book-btn',
  tourWhatsappBtn: 'tour-whatsapp-btn',
  tourTelegramBtn: 'tour-telegram-btn',
  tourItinerary: 'tour-itinerary',

  // Booking form
  bookingForm: 'booking-form',
  bookingName: 'booking-name',
  bookingPhone: 'booking-phone',
  bookingEmail: 'booking-email',
  bookingGuests: 'booking-guests',
  bookingDate: 'booking-date',
  bookingMessage: 'booking-message',
  bookingSubmit: 'booking-submit',

  // Floating contacts
  floatingWhatsapp: 'floating-whatsapp',
  floatingTelegram: 'floating-telegram',

  // Admin
  adminEmail: 'admin-email',
  adminPassword: 'admin-password',
  adminLoginBtn: 'admin-login-btn',
  adminLogout: 'admin-logout',
  adminTabTours: 'admin-tab-tours',
  adminTabBookings: 'admin-tab-bookings',
  adminTabSettings: 'admin-tab-settings',
  adminTestTelegramBtn: 'admin-test-telegram-btn',
  adminSaveSettingsBtn: 'admin-save-settings-btn',
};
